var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttenderRank6(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#attender_rank_6_svg__clip0_1947_6857)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "attender_rank_6_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 200
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.865.477H0v199.188h200.865V.477z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#attender_rank_6_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.335 38.965c-5.345-5.636-14.621-4.171-18.038 2.811-8.93 18.23-6.153 40.877 8.615 56.453 18.43 19.436 48.732 20.688 68.68 3.224L37.334 38.965z",
    fill: "#4C98A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.322 76.494C6.903 74.241-.439 80.112.024 87.876c1.201 20.283 14.761 38.595 35.265 44.818 25.585 7.765 52.553-6.165 61.308-31.241L14.322 76.494z",
    fill: "#338993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.338 122.888c-7.507 1.936-10.76 10.777-6.358 17.177 11.497 16.723 32.546 25.335 53.291 19.994 25.89-6.665 41.771-32.606 36.315-58.606l-42.55 10.953-40.704 10.477.006.005z",
    fill: "#197B85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.531 38.965c5.344-5.636 14.621-4.171 18.037 2.811 8.931 18.23 6.153 40.877-8.614 56.453-18.43 19.436-48.732 20.688-68.68 3.224l59.257-62.488z",
    fill: "#4C98A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.543 76.494c7.419-2.253 14.762 3.618 14.305 11.388-1.202 20.283-14.762 38.594-35.266 44.818-25.585 7.765-52.553-6.165-61.308-31.241l82.269-24.965z",
    fill: "#338993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.522 122.888c7.507 1.936 10.759 10.777 6.358 17.177-11.497 16.723-32.547 25.335-53.291 19.994-25.89-6.665-41.77-32.606-36.315-58.606l42.55 10.953 40.704 10.477-.006.005z",
    fill: "#197B85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.792.477h108.224c6.47 0 11.72 5.27 11.72 11.764v121.336c0 36.47-29.499 66.082-65.832 66.082-36.332 0-65.832-29.612-65.832-66.082V12.241c0-6.494 5.25-11.764 11.72-11.764z",
    fill: "#006C78"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.195 68.306h75.413c4.506 0 8.169 3.67 8.169 8.2V126.1c0 25.418-20.557 46.047-45.873 46.047-25.321 0-45.872-20.635-45.872-46.047V76.506c0-4.523 3.657-8.2 8.169-8.2h-.006z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 70.66c3.211 0 5.825 2.623 5.825 5.846V126.1c0 24.094-19.526 43.694-43.529 43.694-24.002 0-43.528-19.6-43.528-43.694V76.506c0-3.223 2.613-5.847 5.825-5.847h75.413m0-2.353h-75.42c-4.511 0-8.168 3.67-8.168 8.2V126.1c0 25.43 20.54 46.047 45.872 46.047 25.334 0 45.873-20.617 45.873-46.047V76.506c0-4.53-3.657-8.2-8.169-8.2h.012z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.016.477h-44.982L35.072 75.724v51.841l125.3-125.783a11.626 11.626 0 00-5.356-1.305zM95.712 113.241l71.024-71.294V12.571L81.079 98.553l14.633 14.688z",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.25 27.924l1.687 5.206c.188.576.721.964 1.325.964h5.456c1.347 0 1.91 1.736.82 2.53l-4.413 3.217a1.402 1.402 0 00-.504 1.565l1.688 5.206c.416 1.288-1.049 2.359-2.145 1.565l-4.412-3.218a1.394 1.394 0 00-1.635 0l-4.413 3.218c-1.09.794-2.561-.277-2.145-1.565l1.688-5.206a1.405 1.405 0 00-.504-1.565l-4.413-3.217c-1.09-.794-.533-2.53.82-2.53h5.456c.604 0 1.137-.388 1.325-.964l1.688-5.206c.416-1.288 2.232-1.288 2.648 0h-.017z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.25 27.924l1.687 5.206c.188.576.721.964 1.325.964h5.456c1.347 0 1.91 1.736.82 2.53l-4.413 3.217a1.402 1.402 0 00-.504 1.565l1.688 5.206c.416 1.288-1.049 2.359-2.145 1.565l-4.412-3.218a1.394 1.394 0 00-1.635 0l-4.413 3.218c-1.09.794-2.561-.277-2.145-1.565l1.688-5.206a1.405 1.405 0 00-.504-1.565l-4.413-3.217c-1.09-.794-.533-2.53.82-2.53h5.456c.604 0 1.137-.388 1.325-.964l1.688-5.206c.416-1.288 2.232-1.288 2.648 0h-.017z",
    fill: "#FEE066"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M139.675 27.924l1.687 5.206c.188.576.721.964 1.325.964h5.455c1.348 0 1.911 1.736.821 2.53l-4.413 3.217a1.403 1.403 0 00-.504 1.565l1.688 5.206c.416 1.288-1.049 2.359-2.145 1.565l-4.413-3.218a1.395 1.395 0 00-1.635 0l-4.412 3.218c-1.09.794-2.561-.277-2.145-1.565l1.688-5.206a1.406 1.406 0 00-.504-1.565l-4.413-3.217c-1.09-.794-.533-2.53.821-2.53h5.455c.604 0 1.137-.388 1.325-.964l1.687-5.206c.416-1.288 2.233-1.288 2.649 0h-.017z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.675 27.924l1.687 5.206c.188.576.721.964 1.325.964h5.455c1.348 0 1.911 1.736.821 2.53l-4.413 3.217a1.403 1.403 0 00-.504 1.565l1.688 5.206c.416 1.288-1.049 2.359-2.145 1.565l-4.413-3.218a1.395 1.395 0 00-1.635 0l-4.412 3.218c-1.09.794-2.561-.277-2.145-1.565l1.688-5.206a1.406 1.406 0 00-.504-1.565l-4.413-3.217c-1.09-.794-.533-2.53.821-2.53h5.455c.604 0 1.137-.388 1.325-.964l1.687-5.206c.416-1.288 2.233-1.288 2.649 0h-.017z",
    fill: "#FEE066"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M102.029 19.8l2.034 6.282a1.677 1.677 0 001.6 1.165h6.581c1.629 0 2.303 2.088.984 3.047l-5.321 3.882a1.692 1.692 0 00-.609 1.883l2.033 6.282c.504 1.553-1.266 2.847-2.584 1.883l-5.321-3.883a1.675 1.675 0 00-1.975 0l-5.32 3.883c-1.32.958-3.09-.33-2.585-1.883l2.033-6.282a1.693 1.693 0 00-.61-1.883l-5.32-3.882c-1.319-.959-.639-3.047.984-3.047h6.581c.727 0 1.371-.47 1.6-1.165l2.034-6.282c.503-1.553 2.689-1.553 3.193 0h-.012z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.029 19.8l2.034 6.282a1.677 1.677 0 001.6 1.165h6.581c1.629 0 2.303 2.088.984 3.047l-5.321 3.882a1.692 1.692 0 00-.609 1.883l2.033 6.282c.504 1.553-1.266 2.847-2.584 1.883l-5.321-3.883a1.675 1.675 0 00-1.975 0l-5.32 3.883c-1.32.958-3.09-.33-2.585-1.883l2.033-6.282a1.693 1.693 0 00-.61-1.883l-5.32-3.882c-1.319-.959-.639-3.047.984-3.047h6.581c.727 0 1.371-.47 1.6-1.165l2.034-6.282c.503-1.553 2.689-1.553 3.193 0h-.012z",
    fill: "#FEE066"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "attender_rank_6_svg__clip0_1947_6857"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h201v200H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttenderRank6);
export default ForwardRef;